"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
require("core-js/modules/es6.string.small.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _get = _interopRequireDefault(require("lodash/get"));
var _take = _interopRequireDefault(require("lodash/take"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _backdrop = _interopRequireDefault(require("@gravity/backdrop"));
var _button = require("@gravity/button");
var _checkbox = _interopRequireDefault(require("@gravity/checkbox"));
var _jsonMetadata = _interopRequireDefault(require("@gravity/json-metadata"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
require("rc-tooltip/assets/bootstrap_white.css");
var _CheckResaleAvailability = _interopRequireDefault(require("./CheckResaleAvailability"));
var _ProductActions = _interopRequireDefault(require("./ProductActions"));
var _ProductCardDetails = _interopRequireDefault(require("./ProductCardDetails"));
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _ProductImage = _interopRequireDefault(require("./ProductImage"));
var _ProductIndicator = _interopRequireDefault(require("./ProductIndicator"));
var _ProductSlotsBtn = _interopRequireDefault(require("./ProductSlotsBtn"));
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductCard.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2cb95nfw4g() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductCard.js";
  var hash = "52f511aaf16024329df8b3fe3c85b6dabfd7e0a2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductCard.js",
    statementMap: {
      "0": {
        start: {
          line: 42,
          column: 35
        },
        end: {
          line: 42,
          column: 57
        }
      },
      "1": {
        start: {
          line: 44,
          column: 16
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "2": {
        start: {
          line: 46,
          column: 34
        },
        end: {
          line: 46,
          column: 80
        }
      },
      "3": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 61,
          column: 62
        }
      },
      "4": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 67,
          column: 53
        }
      },
      "5": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 81,
          column: 9
        }
      },
      "6": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 106,
          column: 9
        }
      },
      "7": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 120,
          column: 9
        }
      },
      "8": {
        start: {
          line: 140,
          column: 23
        },
        end: {
          line: 164,
          column: 1
        }
      },
      "9": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 145,
          column: 8
        }
      },
      "10": {
        start: {
          line: 166,
          column: 31
        },
        end: {
          line: 170,
          column: 1
        }
      },
      "11": {
        start: {
          line: 172,
          column: 21
        },
        end: {
          line: 176,
          column: 1
        }
      },
      "12": {
        start: {
          line: 178,
          column: 18
        },
        end: {
          line: 187,
          column: 1
        }
      },
      "13": {
        start: {
          line: 189,
          column: 20
        },
        end: {
          line: 204,
          column: 1
        }
      },
      "14": {
        start: {
          line: 206,
          column: 30
        },
        end: {
          line: 210,
          column: 1
        }
      },
      "15": {
        start: {
          line: 212,
          column: 23
        },
        end: {
          line: 214,
          column: 4
        }
      },
      "16": {
        start: {
          line: 216,
          column: 21
        },
        end: {
          line: 216,
          column: 32
        }
      },
      "17": {
        start: {
          line: 218,
          column: 32
        },
        end: {
          line: 269,
          column: 1
        }
      },
      "18": {
        start: {
          line: 219,
          column: 30
        },
        end: {
          line: 219,
          column: 35
        }
      },
      "19": {
        start: {
          line: 220,
          column: 18
        },
        end: {
          line: 220,
          column: 22
        }
      },
      "20": {
        start: {
          line: 221,
          column: 22
        },
        end: {
          line: 221,
          column: 26
        }
      },
      "21": {
        start: {
          line: 222,
          column: 19
        },
        end: {
          line: 222,
          column: 23
        }
      },
      "22": {
        start: {
          line: 223,
          column: 21
        },
        end: {
          line: 223,
          column: 25
        }
      },
      "23": {
        start: {
          line: 224,
          column: 19
        },
        end: {
          line: 224,
          column: 21
        }
      },
      "24": {
        start: {
          line: 225,
          column: 23
        },
        end: {
          line: 225,
          column: 28
        }
      },
      "25": {
        start: {
          line: 226,
          column: 24
        },
        end: {
          line: 226,
          column: 29
        }
      },
      "26": {
        start: {
          line: 228,
          column: 2
        },
        end: {
          line: 258,
          column: 3
        }
      },
      "27": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 33
        }
      },
      "28": {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 236,
          column: 5
        }
      },
      "29": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 29
        }
      },
      "30": {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 54
        }
      },
      "31": {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 233,
          column: 89
        }
      },
      "32": {
        start: {
          line: 234,
          column: 6
        },
        end: {
          line: 234,
          column: 72
        }
      },
      "33": {
        start: {
          line: 235,
          column: 6
        },
        end: {
          line: 235,
          column: 79
        }
      },
      "34": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 257,
          column: 5
        }
      },
      "35": {
        start: {
          line: 238,
          column: 6
        },
        end: {
          line: 238,
          column: 29
        }
      },
      "36": {
        start: {
          line: 239,
          column: 6
        },
        end: {
          line: 241,
          column: 7
        }
      },
      "37": {
        start: {
          line: 240,
          column: 8
        },
        end: {
          line: 240,
          column: 39
        }
      },
      "38": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 244,
          column: 7
        }
      },
      "39": {
        start: {
          line: 243,
          column: 8
        },
        end: {
          line: 243,
          column: 33
        }
      },
      "40": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 247,
          column: 44
        }
      },
      "41": {
        start: {
          line: 248,
          column: 6
        },
        end: {
          line: 250,
          column: 80
        }
      },
      "42": {
        start: {
          line: 251,
          column: 6
        },
        end: {
          line: 253,
          column: 59
        }
      },
      "43": {
        start: {
          line: 254,
          column: 6
        },
        end: {
          line: 256,
          column: 72
        }
      },
      "44": {
        start: {
          line: 259,
          column: 2
        },
        end: {
          line: 268,
          column: 4
        }
      },
      "45": {
        start: {
          line: 310,
          column: 16
        },
        end: {
          line: 310,
          column: 80
        }
      },
      "46": {
        start: {
          line: 311,
          column: 23
        },
        end: {
          line: 311,
          column: 28
        }
      },
      "47": {
        start: {
          line: 312,
          column: 27
        },
        end: {
          line: 312,
          column: 32
        }
      },
      "48": {
        start: {
          line: 313,
          column: 27
        },
        end: {
          line: 313,
          column: 32
        }
      },
      "49": {
        start: {
          line: 325,
          column: 2
        },
        end: {
          line: 337,
          column: 3
        }
      },
      "50": {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 326,
          column: 50
        }
      },
      "51": {
        start: {
          line: 327,
          column: 4
        },
        end: {
          line: 327,
          column: 40
        }
      },
      "52": {
        start: {
          line: 328,
          column: 4
        },
        end: {
          line: 328,
          column: 46
        }
      },
      "53": {
        start: {
          line: 329,
          column: 9
        },
        end: {
          line: 337,
          column: 3
        }
      },
      "54": {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 330,
          column: 47
        }
      },
      "55": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 43
        }
      },
      "56": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 332,
          column: 54
        }
      },
      "57": {
        start: {
          line: 334,
          column: 4
        },
        end: {
          line: 334,
          column: 28
        }
      },
      "58": {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 335,
          column: 42
        }
      },
      "59": {
        start: {
          line: 336,
          column: 4
        },
        end: {
          line: 336,
          column: 53
        }
      },
      "60": {
        start: {
          line: 339,
          column: 37
        },
        end: {
          line: 339,
          column: 44
        }
      },
      "61": {
        start: {
          line: 342,
          column: 23
        },
        end: {
          line: 342,
          column: 70
        }
      },
      "62": {
        start: {
          line: 343,
          column: 2
        },
        end: {
          line: 352,
          column: 3
        }
      },
      "63": {
        start: {
          line: 344,
          column: 4
        },
        end: {
          line: 344,
          column: 70
        }
      },
      "64": {
        start: {
          line: 345,
          column: 9
        },
        end: {
          line: 352,
          column: 3
        }
      },
      "65": {
        start: {
          line: 346,
          column: 4
        },
        end: {
          line: 346,
          column: 33
        }
      },
      "66": {
        start: {
          line: 347,
          column: 4
        },
        end: {
          line: 347,
          column: 57
        }
      },
      "67": {
        start: {
          line: 350,
          column: 4
        },
        end: {
          line: 350,
          column: 41
        }
      },
      "68": {
        start: {
          line: 351,
          column: 4
        },
        end: {
          line: 351,
          column: 53
        }
      },
      "69": {
        start: {
          line: 353,
          column: 18
        },
        end: {
          line: 353,
          column: 41
        }
      },
      "70": {
        start: {
          line: 354,
          column: 21
        },
        end: {
          line: 354,
          column: 54
        }
      },
      "71": {
        start: {
          line: 355,
          column: 29
        },
        end: {
          line: 355,
          column: 91
        }
      },
      "72": {
        start: {
          line: 356,
          column: 23
        },
        end: {
          line: 361,
          column: 4
        }
      },
      "73": {
        start: {
          line: 362,
          column: 14
        },
        end: {
          line: 374,
          column: 3
        }
      },
      "74": {
        start: {
          line: 376,
          column: 25
        },
        end: {
          line: 384,
          column: 3
        }
      },
      "75": {
        start: {
          line: 380,
          column: 36
        },
        end: {
          line: 380,
          column: 69
        }
      },
      "76": {
        start: {
          line: 387,
          column: 22
        },
        end: {
          line: 387,
          column: 72
        }
      },
      "77": {
        start: {
          line: 392,
          column: 2
        },
        end: {
          line: 432,
          column: 3
        }
      },
      "78": {
        start: {
          line: 394,
          column: 6
        },
        end: {
          line: 405,
          column: 13
        }
      },
      "79": {
        start: {
          line: 407,
          column: 4
        },
        end: {
          line: 411,
          column: 6
        }
      },
      "80": {
        start: {
          line: 415,
          column: 9
        },
        end: {
          line: 432,
          column: 3
        }
      },
      "81": {
        start: {
          line: 416,
          column: 4
        },
        end: {
          line: 431,
          column: 6
        }
      },
      "82": {
        start: {
          line: 443,
          column: 6
        },
        end: {
          line: 443,
          column: 72
        }
      },
      "83": {
        start: {
          line: 445,
          column: 36
        },
        end: {
          line: 445,
          column: 92
        }
      },
      "84": {
        start: {
          line: 447,
          column: 43
        },
        end: {
          line: 451,
          column: 3
        }
      },
      "85": {
        start: {
          line: 452,
          column: 20
        },
        end: {
          line: 452,
          column: 76
        }
      },
      "86": {
        start: {
          line: 454,
          column: 2
        },
        end: {
          line: 569,
          column: 4
        }
      },
      "87": {
        start: {
          line: 504,
          column: 12
        },
        end: {
          line: 508,
          column: 13
        }
      },
      "88": {
        start: {
          line: 564,
          column: 47
        },
        end: {
          line: 564,
          column: 79
        }
      },
      "89": {
        start: {
          line: 572,
          column: 0
        },
        end: {
          line: 634,
          column: 2
        }
      },
      "90": {
        start: {
          line: 636,
          column: 0
        },
        end: {
          line: 673,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 46,
            column: 15
          },
          end: {
            line: 46,
            column: 16
          }
        },
        loc: {
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 80
          }
        },
        line: 46
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 9
          }
        },
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 61,
            column: 62
          }
        },
        line: 57
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        },
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 67,
            column: 53
          }
        },
        line: 63
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        },
        line: 70
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        },
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        },
        line: 102
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        loc: {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        line: 109
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 142,
            column: 15
          },
          end: {
            line: 142,
            column: 16
          }
        },
        loc: {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 145,
            column: 8
          }
        },
        line: 143
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 218,
            column: 32
          },
          end: {
            line: 218,
            column: 33
          }
        },
        loc: {
          start: {
            line: 218,
            column: 79
          },
          end: {
            line: 269,
            column: 1
          }
        },
        line: 218
      },
      "8": {
        name: "ProductCard",
        decl: {
          start: {
            line: 274,
            column: 9
          },
          end: {
            line: 274,
            column: 20
          }
        },
        loc: {
          start: {
            line: 309,
            column: 3
          },
          end: {
            line: 570,
            column: 1
          }
        },
        line: 309
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 380,
            column: 30
          },
          end: {
            line: 380,
            column: 31
          }
        },
        loc: {
          start: {
            line: 380,
            column: 36
          },
          end: {
            line: 380,
            column: 69
          }
        },
        line: 380
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 503,
            column: 25
          },
          end: {
            line: 503,
            column: 26
          }
        },
        loc: {
          start: {
            line: 504,
            column: 12
          },
          end: {
            line: 508,
            column: 13
          }
        },
        line: 504
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 564,
            column: 41
          },
          end: {
            line: 564,
            column: 42
          }
        },
        loc: {
          start: {
            line: 564,
            column: 47
          },
          end: {
            line: 564,
            column: 79
          }
        },
        line: 564
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 61,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 13
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 19
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 27
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 39
          }
        }, {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 62
          }
        }],
        line: 57
      },
      "1": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 67,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 13
          }
        }, {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 19
          }
        }, {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 27
          }
        }, {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 39
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 53
          }
        }],
        line: 63
      },
      "2": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 34
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        }],
        line: 70
      },
      "3": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 22
          }
        }, {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }],
        line: 102
      },
      "4": {
        loc: {
          start: {
            line: 104,
            column: 30
          },
          end: {
            line: 104,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 30
          },
          end: {
            line: 104,
            column: 50
          }
        }, {
          start: {
            line: 104,
            column: 54
          },
          end: {
            line: 104,
            column: 63
          }
        }],
        line: 104
      },
      "5": {
        loc: {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 28
          }
        }, {
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        }],
        line: 109
      },
      "6": {
        loc: {
          start: {
            line: 142,
            column: 18
          },
          end: {
            line: 142,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 142,
            column: 33
          },
          end: {
            line: 142,
            column: 35
          }
        }],
        line: 142
      },
      "7": {
        loc: {
          start: {
            line: 228,
            column: 2
          },
          end: {
            line: 258,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 228,
            column: 2
          },
          end: {
            line: 258,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 228
      },
      "8": {
        loc: {
          start: {
            line: 228,
            column: 6
          },
          end: {
            line: 228,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 6
          },
          end: {
            line: 228,
            column: 40
          }
        }, {
          start: {
            line: 228,
            column: 44
          },
          end: {
            line: 228,
            column: 73
          }
        }],
        line: 228
      },
      "9": {
        loc: {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 236,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 236,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 230
      },
      "10": {
        loc: {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 257,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 257,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 237
      },
      "11": {
        loc: {
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 239
      },
      "12": {
        loc: {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 244,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 244,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 242
      },
      "13": {
        loc: {
          start: {
            line: 245,
            column: 21
          },
          end: {
            line: 247,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 246,
            column: 10
          },
          end: {
            line: 246,
            column: 46
          }
        }, {
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 247,
            column: 43
          }
        }],
        line: 245
      },
      "14": {
        loc: {
          start: {
            line: 248,
            column: 19
          },
          end: {
            line: 250,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 249,
            column: 10
          },
          end: {
            line: 249,
            column: 83
          }
        }, {
          start: {
            line: 250,
            column: 10
          },
          end: {
            line: 250,
            column: 79
          }
        }],
        line: 248
      },
      "15": {
        loc: {
          start: {
            line: 251,
            column: 23
          },
          end: {
            line: 253,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 252,
            column: 10
          },
          end: {
            line: 252,
            column: 62
          }
        }, {
          start: {
            line: 253,
            column: 10
          },
          end: {
            line: 253,
            column: 58
          }
        }],
        line: 251
      },
      "16": {
        loc: {
          start: {
            line: 254,
            column: 24
          },
          end: {
            line: 256,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 255,
            column: 10
          },
          end: {
            line: 255,
            column: 75
          }
        }, {
          start: {
            line: 256,
            column: 10
          },
          end: {
            line: 256,
            column: 71
          }
        }],
        line: 254
      },
      "17": {
        loc: {
          start: {
            line: 325,
            column: 2
          },
          end: {
            line: 337,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 325,
            column: 2
          },
          end: {
            line: 337,
            column: 3
          }
        }, {
          start: {
            line: 329,
            column: 9
          },
          end: {
            line: 337,
            column: 3
          }
        }],
        line: 325
      },
      "18": {
        loc: {
          start: {
            line: 326,
            column: 13
          },
          end: {
            line: 326,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 326,
            column: 13
          },
          end: {
            line: 326,
            column: 31
          }
        }, {
          start: {
            line: 326,
            column: 35
          },
          end: {
            line: 326,
            column: 49
          }
        }],
        line: 326
      },
      "19": {
        loc: {
          start: {
            line: 329,
            column: 9
          },
          end: {
            line: 337,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 329,
            column: 9
          },
          end: {
            line: 337,
            column: 3
          }
        }, {
          start: {
            line: 333,
            column: 9
          },
          end: {
            line: 337,
            column: 3
          }
        }],
        line: 329
      },
      "20": {
        loc: {
          start: {
            line: 330,
            column: 13
          },
          end: {
            line: 330,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 330,
            column: 13
          },
          end: {
            line: 330,
            column: 28
          }
        }, {
          start: {
            line: 330,
            column: 32
          },
          end: {
            line: 330,
            column: 46
          }
        }],
        line: 330
      },
      "21": {
        loc: {
          start: {
            line: 332,
            column: 17
          },
          end: {
            line: 332,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 17
          },
          end: {
            line: 332,
            column: 36
          }
        }, {
          start: {
            line: 332,
            column: 40
          },
          end: {
            line: 332,
            column: 53
          }
        }],
        line: 332
      },
      "22": {
        loc: {
          start: {
            line: 336,
            column: 17
          },
          end: {
            line: 336,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 336,
            column: 17
          },
          end: {
            line: 336,
            column: 35
          }
        }, {
          start: {
            line: 336,
            column: 39
          },
          end: {
            line: 336,
            column: 52
          }
        }],
        line: 336
      },
      "23": {
        loc: {
          start: {
            line: 343,
            column: 2
          },
          end: {
            line: 352,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 343,
            column: 2
          },
          end: {
            line: 352,
            column: 3
          }
        }, {
          start: {
            line: 345,
            column: 9
          },
          end: {
            line: 352,
            column: 3
          }
        }],
        line: 343
      },
      "24": {
        loc: {
          start: {
            line: 344,
            column: 25
          },
          end: {
            line: 344,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 344,
            column: 25
          },
          end: {
            line: 344,
            column: 43
          }
        }, {
          start: {
            line: 344,
            column: 47
          },
          end: {
            line: 344,
            column: 69
          }
        }],
        line: 344
      },
      "25": {
        loc: {
          start: {
            line: 345,
            column: 9
          },
          end: {
            line: 352,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 345,
            column: 9
          },
          end: {
            line: 352,
            column: 3
          }
        }, {
          start: {
            line: 348,
            column: 9
          },
          end: {
            line: 352,
            column: 3
          }
        }],
        line: 345
      },
      "26": {
        loc: {
          start: {
            line: 345,
            column: 25
          },
          end: {
            line: 345,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 345,
            column: 25
          },
          end: {
            line: 345,
            column: 31
          }
        }, {
          start: {
            line: 345,
            column: 35
          },
          end: {
            line: 345,
            column: 37
          }
        }],
        line: 345
      },
      "27": {
        loc: {
          start: {
            line: 347,
            column: 25
          },
          end: {
            line: 347,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 347,
            column: 25
          },
          end: {
            line: 347,
            column: 37
          }
        }, {
          start: {
            line: 347,
            column: 41
          },
          end: {
            line: 347,
            column: 56
          }
        }],
        line: 347
      },
      "28": {
        loc: {
          start: {
            line: 351,
            column: 21
          },
          end: {
            line: 351,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 351,
            column: 21
          },
          end: {
            line: 351,
            column: 37
          }
        }, {
          start: {
            line: 351,
            column: 41
          },
          end: {
            line: 351,
            column: 52
          }
        }],
        line: 351
      },
      "29": {
        loc: {
          start: {
            line: 354,
            column: 40
          },
          end: {
            line: 354,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 354,
            column: 40
          },
          end: {
            line: 354,
            column: 46
          }
        }, {
          start: {
            line: 354,
            column: 50
          },
          end: {
            line: 354,
            column: 52
          }
        }],
        line: 354
      },
      "30": {
        loc: {
          start: {
            line: 355,
            column: 29
          },
          end: {
            line: 355,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 355,
            column: 29
          },
          end: {
            line: 355,
            column: 56
          }
        }, {
          start: {
            line: 355,
            column: 60
          },
          end: {
            line: 355,
            column: 91
          }
        }],
        line: 355
      },
      "31": {
        loc: {
          start: {
            line: 362,
            column: 14
          },
          end: {
            line: 374,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 362,
            column: 14
          },
          end: {
            line: 362,
            column: 23
          }
        }, {
          start: {
            line: 363,
            column: 4
          },
          end: {
            line: 373,
            column: 6
          }
        }],
        line: 362
      },
      "32": {
        loc: {
          start: {
            line: 376,
            column: 25
          },
          end: {
            line: 384,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 376,
            column: 25
          },
          end: {
            line: 376,
            column: 45
          }
        }, {
          start: {
            line: 377,
            column: 4
          },
          end: {
            line: 383,
            column: 28
          }
        }],
        line: 376
      },
      "33": {
        loc: {
          start: {
            line: 392,
            column: 2
          },
          end: {
            line: 432,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 392,
            column: 2
          },
          end: {
            line: 432,
            column: 3
          }
        }, {
          start: {
            line: 415,
            column: 9
          },
          end: {
            line: 432,
            column: 3
          }
        }],
        line: 392
      },
      "34": {
        loc: {
          start: {
            line: 392,
            column: 6
          },
          end: {
            line: 392,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 392,
            column: 6
          },
          end: {
            line: 392,
            column: 13
          }
        }, {
          start: {
            line: 392,
            column: 17
          },
          end: {
            line: 392,
            column: 27
          }
        }],
        line: 392
      },
      "35": {
        loc: {
          start: {
            line: 395,
            column: 9
          },
          end: {
            line: 399,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 396,
            column: 10
          },
          end: {
            line: 396,
            column: 76
          }
        }, {
          start: {
            line: 398,
            column: 10
          },
          end: {
            line: 398,
            column: 88
          }
        }],
        line: 395
      },
      "36": {
        loc: {
          start: {
            line: 400,
            column: 9
          },
          end: {
            line: 404,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 400,
            column: 9
          },
          end: {
            line: 400,
            column: 31
          }
        }, {
          start: {
            line: 401,
            column: 10
          },
          end: {
            line: 403,
            column: 14
          }
        }],
        line: 400
      },
      "37": {
        loc: {
          start: {
            line: 415,
            column: 9
          },
          end: {
            line: 432,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 415,
            column: 9
          },
          end: {
            line: 432,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 415
      },
      "38": {
        loc: {
          start: {
            line: 421,
            column: 13
          },
          end: {
            line: 427,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 422,
            column: 14
          },
          end: {
            line: 422,
            column: 89
          }
        }, {
          start: {
            line: 424,
            column: 14
          },
          end: {
            line: 426,
            column: 16
          }
        }],
        line: 421
      },
      "39": {
        loc: {
          start: {
            line: 458,
            column: 9
          },
          end: {
            line: 477,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 458,
            column: 10
          },
          end: {
            line: 458,
            column: 18
          }
        }, {
          start: {
            line: 459,
            column: 10
          },
          end: {
            line: 459,
            column: 20
          }
        }, {
          start: {
            line: 460,
            column: 10
          },
          end: {
            line: 460,
            column: 25
          }
        }, {
          start: {
            line: 461,
            column: 10
          },
          end: {
            line: 461,
            column: 48
          }
        }, {
          start: {
            line: 461,
            column: 52
          },
          end: {
            line: 461,
            column: 76
          }
        }, {
          start: {
            line: 462,
            column: 12
          },
          end: {
            line: 468,
            column: 29
          }
        }, {
          start: {
            line: 470,
            column: 11
          },
          end: {
            line: 470,
            column: 19
          }
        }, {
          start: {
            line: 471,
            column: 12
          },
          end: {
            line: 471,
            column: 22
          }
        }, {
          start: {
            line: 472,
            column: 14
          },
          end: {
            line: 476,
            column: 31
          }
        }],
        line: 458
      },
      "40": {
        loc: {
          start: {
            line: 478,
            column: 9
          },
          end: {
            line: 480,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 478,
            column: 9
          },
          end: {
            line: 478,
            column: 18
          }
        }, {
          start: {
            line: 479,
            column: 10
          },
          end: {
            line: 479,
            column: 94
          }
        }],
        line: 478
      },
      "41": {
        loc: {
          start: {
            line: 482,
            column: 9
          },
          end: {
            line: 496,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 482,
            column: 10
          },
          end: {
            line: 482,
            column: 19
          }
        }, {
          start: {
            line: 482,
            column: 23
          },
          end: {
            line: 482,
            column: 32
          }
        }, {
          start: {
            line: 482,
            column: 36
          },
          end: {
            line: 482,
            column: 51
          }
        }, {
          start: {
            line: 483,
            column: 10
          },
          end: {
            line: 495,
            column: 12
          }
        }],
        line: 482
      },
      "42": {
        loc: {
          start: {
            line: 487,
            column: 22
          },
          end: {
            line: 487,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 487,
            column: 22
          },
          end: {
            line: 487,
            column: 38
          }
        }, {
          start: {
            line: 487,
            column: 42
          },
          end: {
            line: 487,
            column: 50
          }
        }],
        line: 487
      },
      "43": {
        loc: {
          start: {
            line: 498,
            column: 7
          },
          end: {
            line: 542,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 499,
            column: 8
          },
          end: {
            line: 527,
            column: 10
          }
        }, {
          start: {
            line: 529,
            column: 8
          },
          end: {
            line: 541,
            column: 9
          }
        }],
        line: 498
      },
      "44": {
        loc: {
          start: {
            line: 513,
            column: 12
          },
          end: {
            line: 515,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 514,
            column: 16
          },
          end: {
            line: 514,
            column: 64
          }
        }, {
          start: {
            line: 515,
            column: 16
          },
          end: {
            line: 515,
            column: 65
          }
        }],
        line: 513
      },
      "45": {
        loc: {
          start: {
            line: 518,
            column: 12
          },
          end: {
            line: 523,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 519,
            column: 14
          },
          end: {
            line: 522,
            column: 16
          }
        }, {
          start: {
            line: 523,
            column: 16
          },
          end: {
            line: 523,
            column: 20
          }
        }],
        line: 518
      },
      "46": {
        loc: {
          start: {
            line: 529,
            column: 8
          },
          end: {
            line: 541,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 529,
            column: 8
          },
          end: {
            line: 529,
            column: 22
          }
        }, {
          start: {
            line: 530,
            column: 8
          },
          end: {
            line: 530,
            column: 14
          }
        }, {
          start: {
            line: 531,
            column: 10
          },
          end: {
            line: 540,
            column: 12
          }
        }],
        line: 529
      },
      "47": {
        loc: {
          start: {
            line: 543,
            column: 7
          },
          end: {
            line: 549,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 543,
            column: 7
          },
          end: {
            line: 543,
            column: 25
          }
        }, {
          start: {
            line: 544,
            column: 8
          },
          end: {
            line: 548,
            column: 10
          }
        }],
        line: 543
      },
      "48": {
        loc: {
          start: {
            line: 550,
            column: 7
          },
          end: {
            line: 560,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 550,
            column: 7
          },
          end: {
            line: 550,
            column: 25
          }
        }, {
          start: {
            line: 551,
            column: 8
          },
          end: {
            line: 551,
            column: 14
          }
        }, {
          start: {
            line: 552,
            column: 10
          },
          end: {
            line: 559,
            column: 12
          }
        }],
        line: 550
      },
      "49": {
        loc: {
          start: {
            line: 561,
            column: 7
          },
          end: {
            line: 566,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 561,
            column: 7
          },
          end: {
            line: 561,
            column: 39
          }
        }, {
          start: {
            line: 562,
            column: 8
          },
          end: {
            line: 565,
            column: 10
          }
        }],
        line: 561
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0, 0, 0, 0, 0, 0, 0, 0],
      "40": [0, 0],
      "41": [0, 0, 0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0, 0],
      "47": [0, 0],
      "48": [0, 0, 0],
      "49": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "52f511aaf16024329df8b3fe3c85b6dabfd7e0a2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2cb95nfw4g = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2cb95nfw4g();
var ACCESSIBILITY_TITLE_PREFIX = (cov_2cb95nfw4g().s[0]++, 'accessibility_title_');
var Wrapper = (cov_2cb95nfw4g().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(_ref) {
    var productId = _ref.productId;
    cov_2cb95nfw4g().f[0]++;
    cov_2cb95nfw4g().s[2]++;
    return "stx-ProductCard-".concat(productId, " stx-ProductCard");
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      height: 100%;\n      justify-content: space-between;\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n      ", ";\n      ", ";\n\n      ", ";\n    "])), function (props) {
  cov_2cb95nfw4g().f[1]++;
  cov_2cb95nfw4g().s[3]++;
  return (cov_2cb95nfw4g().b[0][0]++, props) && (cov_2cb95nfw4g().b[0][1]++, props.theme) && (cov_2cb95nfw4g().b[0][2]++, props.theme.product) && (cov_2cb95nfw4g().b[0][3]++, props.theme.product.cardBgColor) && (cov_2cb95nfw4g().b[0][4]++, "background-color:".concat(props.theme.product.cardBgColor, ";"));
}, function (props) {
  cov_2cb95nfw4g().f[2]++;
  cov_2cb95nfw4g().s[4]++;
  return (cov_2cb95nfw4g().b[1][0]++, props) && (cov_2cb95nfw4g().b[1][1]++, props.theme) && (cov_2cb95nfw4g().b[1][2]++, props.theme.product) && (cov_2cb95nfw4g().b[1][3]++, props.theme.product.cardPadding) && (cov_2cb95nfw4g().b[1][4]++, "padding:".concat(props.theme.product.cardPadding, ";"));
}, function (props) {
  cov_2cb95nfw4g().f[3]++;
  cov_2cb95nfw4g().s[5]++;
  return (cov_2cb95nfw4g().b[2][0]++, props.isShowSelectCheckbox) && (cov_2cb95nfw4g().b[2][1]++, "\n          flex-wrap: wrap;\n          justify-content: flex-end;\n          flex-direction: row;\n          .stx-ProductCardMainContent {\n            width: 85%;\n          }\n          .stx-ProductActions {\n            width: 85%;\n          }\n        ");
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      height: 100%;\n      justify-content: space-between;\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n      border-radius: var(--generalBorderRadius, 12px);\n      ", ";\n      padding: ", ";\n      background-color: ", ";\n\n      :has(.stx-MainActionArea:hover) {\n        .stx-ImageWrapper {\n          transform: scale(", ");\n        }\n      }\n\n      ", ";\n\n      ", ";\n\n      > .stx-ProductActions {\n        gap: ", "px;\n        padding-bottom: 0;\n\n        > div {\n          margin: 0;\n\n          > .g-Button {\n            font-weight: ", ";\n            width: 100%;\n            height: var(--inputButtonHeight, 40px);\n          }\n        }\n      }\n    "])), (0, _utils.boxShadowOf)('Card', {
  defaultValue: _themeMapper.evolutionTheme.card.boxShadow
}), _themeMapper.evolutionTheme.card.padding, _themeMapper.evolutionTheme.card.bgColor, (0, _get.default)(_themeMapper.evolutionTheme, 'image.interactiveScale', 1.05), function (_ref2) {
  var theme = _ref2.theme;
  cov_2cb95nfw4g().f[4]++;
  cov_2cb95nfw4g().s[6]++;
  return (cov_2cb95nfw4g().b[3][0]++, theme === null || theme === void 0 ? void 0 : theme.product) && (cov_2cb95nfw4g().b[3][1]++, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n          background-color: ", ";\n          padding: ", ";\n        "])), (cov_2cb95nfw4g().b[4][0]++, theme.contentBgColor) || (cov_2cb95nfw4g().b[4][1]++, '#ffffff'), theme.product.cardPadding));
}, function (_ref3) {
  var isShowSelectCheckbox = _ref3.isShowSelectCheckbox;
  cov_2cb95nfw4g().f[5]++;
  cov_2cb95nfw4g().s[7]++;
  return (cov_2cb95nfw4g().b[5][0]++, isShowSelectCheckbox) && (cov_2cb95nfw4g().b[5][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n          flex-wrap: wrap;\n          justify-content: flex-end;\n          flex-direction: row;\n          .stx-ProductCardMainContent {\n            width: 85%;\n          }\n          .stx-ProductActions {\n            width: 85%;\n          }\n        "]))));
}, _themeMapper.evolutionTheme.spacings.md, _themeMapper.evolutionTheme.fontWeight.medium))));
var MainActionArea = (cov_2cb95nfw4g().s[8]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(_styledComponents.default.a.attrs({
  className: function className(_ref4) {
    var _ref4$themeQueries = _ref4.themeQueries,
      themeQueries = _ref4$themeQueries === void 0 ? (cov_2cb95nfw4g().b[6][0]++, {}) : _ref4$themeQueries;
    cov_2cb95nfw4g().f[6]++;
    cov_2cb95nfw4g().s[9]++;
    return (0, _utils.classNames)({
      'stx-MainActionArea': themeQueries.EVOLUTION
    });
  }
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    line-height: 0;\n    font-size: 0;\n    color: transparent;\n    h3 {\n      position: absolute;\n      left: 0px;\n      width: 1px;\n      height: 1px;\n      overflow: hidden;\n    }\n  "]))))));
var ProductCardMainContent = (cov_2cb95nfw4g().s[10]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductCardMainContent'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n"]))));
var ImageWrapper = (cov_2cb95nfw4g().s[11]++, _styledComponents.default.div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  position: relative;\n  width: 100%;\n"]))));
var ImageInfo = (cov_2cb95nfw4g().s[12]++, _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  ", ";\n"])), _stylingConstants.default.mediaQueries.tablet(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n    display:block;\n"])))));
var InfoContent = (cov_2cb95nfw4g().s[13]++, _styledComponents.default.div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  bottom: 0;\n  width: 100%;\n  text-align: center;\n  white-space: normal;\n  color: white;\n  span,\n  a {\n    padding: ", ";\n    display: flex;\n    justify-content: center;\n    text-decoration: none;\n    font-size: ", ";\n  }\n"])), _stylingConstants.default.spacing.small, _stylingConstants.default.font.sizeS));
var SelectCheckboxWrapper = (cov_2cb95nfw4g().s[14]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductCard-SelectCheckbox'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  width: 15%;\n"]))));
var TooltipWrapper = (cov_2cb95nfw4g().s[15]++, (0, _styledComponents.default)(_rcTooltip.default).attrs({
  className: "stx-tooltip"
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)([""]))));
var TitleWrapper = (cov_2cb95nfw4g().s[16]++, _styledComponents.default.h3(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)([""]))));
cov_2cb95nfw4g().s[17]++;
var buildStreamOnlineConfig = function buildStreamOnlineConfig(product, performance, timeslot, displayAs) {
  cov_2cb95nfw4g().f[7]++;
  var shouldDisplayWatchNow = (cov_2cb95nfw4g().s[18]++, false);
  var productId = (cov_2cb95nfw4g().s[19]++, null);
  var performanceId = (cov_2cb95nfw4g().s[20]++, null);
  var timeslotId = (cov_2cb95nfw4g().s[21]++, null);
  var buyActionUrl = (cov_2cb95nfw4g().s[22]++, null);
  var accessCode = (cov_2cb95nfw4g().s[23]++, '');
  var isAlreadyWatch = (cov_2cb95nfw4g().s[24]++, false);
  var isLoginRequired = (cov_2cb95nfw4g().s[25]++, false);
  cov_2cb95nfw4g().s[26]++;
  if ((cov_2cb95nfw4g().b[8][0]++, product.streamOnline !== undefined) && (cov_2cb95nfw4g().b[8][1]++, product.streamOnline !== null)) {
    cov_2cb95nfw4g().b[7][0]++;
    cov_2cb95nfw4g().s[27]++;
    shouldDisplayWatchNow = true;
    cov_2cb95nfw4g().s[28]++;
    if (displayAs === 'PRODUCT') {
      cov_2cb95nfw4g().b[9][0]++;
      cov_2cb95nfw4g().s[29]++;
      productId = product.id;
      cov_2cb95nfw4g().s[30]++;
      buyActionUrl = (0, _get.default)(product, 'action.buy', null);
      cov_2cb95nfw4g().s[31]++;
      accessCode = (0, _get.default)(product, 'streamOnline.streamContentValue.accessCredentials', '');
      cov_2cb95nfw4g().s[32]++;
      isAlreadyWatch = (0, _get.default)(product, 'streamOnline.alreadyWatch', false);
      cov_2cb95nfw4g().s[33]++;
      isLoginRequired = (0, _get.default)(product, 'streamOnline.publicTariffLoginRequired');
    } else {
      cov_2cb95nfw4g().b[9][1]++;
    }
    cov_2cb95nfw4g().s[34]++;
    if (displayAs === 'PERFORMANCE') {
      cov_2cb95nfw4g().b[10][0]++;
      cov_2cb95nfw4g().s[35]++;
      productId = product.id;
      cov_2cb95nfw4g().s[36]++;
      if (performance) {
        cov_2cb95nfw4g().b[11][0]++;
        cov_2cb95nfw4g().s[37]++;
        performanceId = performance.id;
      } else {
        cov_2cb95nfw4g().b[11][1]++;
      }
      cov_2cb95nfw4g().s[38]++;
      if (timeslot) {
        cov_2cb95nfw4g().b[12][0]++;
        cov_2cb95nfw4g().s[39]++;
        timeslotId = timeslot.id;
      } else {
        cov_2cb95nfw4g().b[12][1]++;
      }
      cov_2cb95nfw4g().s[40]++;
      buyActionUrl = performance ? (cov_2cb95nfw4g().b[13][0]++, (0, _get.default)(performance, 'action.buy', null)) : (cov_2cb95nfw4g().b[13][1]++, (0, _get.default)(timeslot, 'action.buy', null));
      cov_2cb95nfw4g().s[41]++;
      accessCode = performance ? (cov_2cb95nfw4g().b[14][0]++, (0, _get.default)(performance, 'streamOnline.streamContentValue.accessCredentials', '')) : (cov_2cb95nfw4g().b[14][1]++, (0, _get.default)(product, 'streamOnline.streamContentValue.accessCredentials', ''));
      cov_2cb95nfw4g().s[42]++;
      isAlreadyWatch = performance ? (cov_2cb95nfw4g().b[15][0]++, (0, _get.default)(performance, 'streamOnline.alreadyWatch', false)) : (cov_2cb95nfw4g().b[15][1]++, (0, _get.default)(product, 'streamOnline.alreadyWatch', false));
      cov_2cb95nfw4g().s[43]++;
      isLoginRequired = performance ? (cov_2cb95nfw4g().b[16][0]++, (0, _get.default)(performance, 'streamOnline.publicTariffLoginRequired', false)) : (cov_2cb95nfw4g().b[16][1]++, (0, _get.default)(product, 'streamOnline.publicTariffLoginRequired', false));
    } else {
      cov_2cb95nfw4g().b[10][1]++;
    }
  } else {
    cov_2cb95nfw4g().b[7][1]++;
  }
  cov_2cb95nfw4g().s[44]++;
  return {
    shouldDisplayWatchNow: shouldDisplayWatchNow,
    productId: productId,
    performanceId: performanceId,
    timeslotId: timeslotId,
    buyActionUrl: buyActionUrl,
    accessCode: accessCode,
    isAlreadyWatch: isAlreadyWatch,
    isLoginRequired: isLoginRequired
  };
};

/*
 * Component to display a product as a card
 */
function ProductCard(_ref5) {
  var aspectRatio = _ref5.aspectRatio,
    maxOccurrences = _ref5.maxOccurrences,
    product = _ref5.product,
    showActions = _ref5.showActions,
    showImage = _ref5.showImage,
    showOccurrences = _ref5.showOccurrences,
    showTitle = _ref5.showTitle,
    waitingListEnabled = _ref5.waitingListEnabled,
    showDescription = _ref5.showDescription,
    showPrice = _ref5.showPrice,
    currencyCode = _ref5.currencyCode,
    performance = _ref5.performance,
    timeslot = _ref5.timeslot,
    isSignedIn = _ref5.isSignedIn,
    showDate = _ref5.showDate,
    showTime = _ref5.showTime,
    productTitleFontSize = _ref5.productTitleFontSize,
    onActionClick = _ref5.onActionClick,
    isShowSelectCheckbox = _ref5.isShowSelectCheckbox,
    isSelected = _ref5.isSelected,
    onProductSelectChange = _ref5.onProductSelectChange,
    ecommerceGoogleTracking = _ref5.ecommerceGoogleTracking,
    isLandingPage = _ref5.isLandingPage,
    onWatchStreamOnline = _ref5.onWatchStreamOnline,
    replaceProductNameByPerformance = _ref5.replaceProductNameByPerformance,
    displayAs = _ref5.displayAs,
    keyPrefix = _ref5.keyPrefix,
    intl = _ref5.intl,
    resaleAvailability = _ref5.resaleAvailability,
    actionButtonVariant = _ref5.actionButtonVariant,
    themeQueries = _ref5.themeQueries,
    lastItemId = _ref5.lastItemId,
    columns = _ref5.columns,
    showAsGrid = _ref5.showAsGrid;
  cov_2cb95nfw4g().f[8]++;
  var props = (cov_2cb95nfw4g().s[45]++, {
    onActionClick: onActionClick,
    product: product,
    performance: performance,
    ecommerceGoogleTracking: ecommerceGoogleTracking
  });
  var displayActions = (cov_2cb95nfw4g().s[46]++, false);
  var displayOccurrences = (cov_2cb95nfw4g().s[47]++, false);
  var displayWaitingList = (cov_2cb95nfw4g().s[48]++, false);
  // specific to performance, timeslot or take product as default.
  /*
   * Currently we have two modes (to be backward compatible)
   * The performance define the restricedAdvantage as there is at least one restricted advantage
   * The timeslot and product define the restricted as only salable through restricted advantage
   * Then the not onSales is directly taken for the performance but for timeslot and product it is either restricted advantage, either not on sales.
   * With advantage doesn't change, but it is slightly different,
   */
  var action;
  var notOnSales;
  var restrictedAdv;
  cov_2cb95nfw4g().s[49]++;
  if (performance) {
    cov_2cb95nfw4g().b[17][0]++;
    cov_2cb95nfw4g().s[50]++;
    action = (cov_2cb95nfw4g().b[18][0]++, performance.action) || (cov_2cb95nfw4g().b[18][1]++, product.action);
    cov_2cb95nfw4g().s[51]++;
    notOnSales = performance.notOnSales;
    cov_2cb95nfw4g().s[52]++;
    restrictedAdv = performance.restrictedAdv;
  } else {
    cov_2cb95nfw4g().b[17][1]++;
    cov_2cb95nfw4g().s[53]++;
    if (timeslot) {
      cov_2cb95nfw4g().b[19][0]++;
      cov_2cb95nfw4g().s[54]++;
      action = (cov_2cb95nfw4g().b[20][0]++, timeslot.action) || (cov_2cb95nfw4g().b[20][1]++, product.action);
      cov_2cb95nfw4g().s[55]++;
      restrictedAdv = timeslot.restrictedAdv;
      cov_2cb95nfw4g().s[56]++;
      notOnSales = (cov_2cb95nfw4g().b[21][0]++, timeslot.notOnSales) || (cov_2cb95nfw4g().b[21][1]++, restrictedAdv);
    } else {
      cov_2cb95nfw4g().b[19][1]++;
      cov_2cb95nfw4g().s[57]++;
      action = product.action;
      cov_2cb95nfw4g().s[58]++;
      restrictedAdv = product.restrictedAdv;
      cov_2cb95nfw4g().s[59]++;
      notOnSales = (cov_2cb95nfw4g().b[22][0]++, product.notOnSales) || (cov_2cb95nfw4g().b[22][1]++, restrictedAdv);
    }
  }
  var _ref6 = (cov_2cb95nfw4g().s[60]++, product),
    internetDescriptionUrl = _ref6.internetDescriptionUrl;

  // the display of action has the priority on the occurrences if there is more than one actionName
  var availability = (cov_2cb95nfw4g().s[61]++, (0, _utils2.getAvailability)(product, performance, timeslot));
  cov_2cb95nfw4g().s[62]++;
  if (availability === 'NONE') {
    cov_2cb95nfw4g().b[23][0]++;
    cov_2cb95nfw4g().s[63]++;
    displayWaitingList = (cov_2cb95nfw4g().b[24][0]++, waitingListEnabled) && (cov_2cb95nfw4g().b[24][1]++, product.waitingListUrl);
  } else {
    cov_2cb95nfw4g().b[23][1]++;
    cov_2cb95nfw4g().s[64]++;
    if ((0, _keys.default)((cov_2cb95nfw4g().b[26][0]++, action) || (cov_2cb95nfw4g().b[26][1]++, {})).length > 1) {
      cov_2cb95nfw4g().b[25][0]++;
      cov_2cb95nfw4g().s[65]++;
      displayActions = showActions;
      cov_2cb95nfw4g().s[66]++;
      displayOccurrences = (cov_2cb95nfw4g().b[27][0]++, !showActions) && (cov_2cb95nfw4g().b[27][1]++, showOccurrences);
    } else {
      cov_2cb95nfw4g().b[25][1]++;
      cov_2cb95nfw4g().s[67]++;
      // if there is only one action, it is the opposite
      displayOccurrences = showOccurrences;
      cov_2cb95nfw4g().s[68]++;
      displayActions = (cov_2cb95nfw4g().b[28][0]++, !showOccurrences) && (cov_2cb95nfw4g().b[28][1]++, showActions);
    }
  }
  var soldOut = (cov_2cb95nfw4g().s[69]++, availability === 'NONE');
  var mainAction = (cov_2cb95nfw4g().s[70]++, (0, _take.default)((0, _values.default)((cov_2cb95nfw4g().b[29][0]++, action) || (cov_2cb95nfw4g().b[29][1]++, {}))));
  var usePerformanceName = (cov_2cb95nfw4g().s[71]++, (cov_2cb95nfw4g().b[30][0]++, displayAs === 'PERFORMANCE') && (cov_2cb95nfw4g().b[30][1]++, replaceProductNameByPerformance));
  var productTitle = (cov_2cb95nfw4g().s[72]++, _ProductHelper.default.getProductTitle({
    product: product,
    performance: performance,
    intl: intl,
    usePerformanceName: usePerformanceName
  }));
  var image = (cov_2cb95nfw4g().s[73]++, (cov_2cb95nfw4g().b[31][0]++, showImage) && (cov_2cb95nfw4g().b[31][1]++, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    product: product,
    performance: performance,
    aspectRatio: aspectRatio,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    isLandingPage: isLandingPage,
    alt: productTitle,
    lastItemId: lastItemId,
    columns: columns,
    showAsGrid: showAsGrid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 363,
      columnNumber: 5
    }
  })));
  var selectCheckbox = (cov_2cb95nfw4g().s[74]++, (cov_2cb95nfw4g().b[32][0]++, isShowSelectCheckbox) && (cov_2cb95nfw4g().b[32][1]++, /*#__PURE__*/_react.default.createElement(SelectCheckboxWrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 377,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    checked: isSelected,
    handleCheckboxChange: function handleCheckboxChange() {
      cov_2cb95nfw4g().f[9]++;
      cov_2cb95nfw4g().s[75]++;
      return onProductSelectChange(product.id);
    },
    isFullyControlledByProps: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 378,
      columnNumber: 7
    }
  }))));

  // STX-100489: Tooltip to display long description as html format
  var htmlTooltip = (cov_2cb95nfw4g().s[76]++, (0, _utils2.createDescriptionHtmlTooltip)(performance, product));

  /**
   * If it is not salable, the backdrop should completely wrap the image
   */
  cov_2cb95nfw4g().s[77]++;
  if ((cov_2cb95nfw4g().b[34][0]++, soldOut) || (cov_2cb95nfw4g().b[34][1]++, notOnSales)) {
    cov_2cb95nfw4g().b[33][0]++;
    var backdropContent = (cov_2cb95nfw4g().s[78]++, /*#__PURE__*/_react.default.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 394,
        columnNumber: 7
      }
    }, isSignedIn ? (cov_2cb95nfw4g().b[35][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.restrictedOfferMsg',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 396,
        columnNumber: 11
      }
    })) : (cov_2cb95nfw4g().b[35][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.restrictedOfferMsgWithoutLogin',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 398,
        columnNumber: 11
      }
    })), (cov_2cb95nfw4g().b[36][0]++, internetDescriptionUrl) && (cov_2cb95nfw4g().b[36][1]++, /*#__PURE__*/_react.default.createElement("a", {
      target: "_blank",
      href: internetDescriptionUrl,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 401,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: "gravity.Product.moreInfo",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 402,
        columnNumber: 13
      }
    })))));
    cov_2cb95nfw4g().s[79]++;
    image = /*#__PURE__*/_react.default.createElement(_backdrop.default, {
      animated: restrictedAdv,
      backdropContent: backdropContent,
      restricted: notOnSales,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 408,
        columnNumber: 7
      }
    }, image);
    /**
     * If it is salable but there is at least one restricted advantage, display a small info
     */
  } else {
    cov_2cb95nfw4g().b[33][1]++;
    cov_2cb95nfw4g().s[80]++;
    if (restrictedAdv) {
      cov_2cb95nfw4g().b[37][0]++;
      cov_2cb95nfw4g().s[81]++;
      image = /*#__PURE__*/_react.default.createElement(ImageWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 417,
          columnNumber: 7
        }
      }, image, /*#__PURE__*/_react.default.createElement(ImageInfo, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 419,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(InfoContent, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 420,
          columnNumber: 11
        }
      }, isSignedIn ? (cov_2cb95nfw4g().b[38][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.Product.productContainRestrictedAdv',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 422,
          columnNumber: 15
        }
      })) : (cov_2cb95nfw4g().b[38][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.Product.productContainRestrictedAdvWithoutLogin',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 424,
          columnNumber: 15
        }
      })))));
    } else {
      cov_2cb95nfw4g().b[37][1]++;
    }
  }
  var _ref7 = (cov_2cb95nfw4g().s[82]++, buildStreamOnlineConfig(product, performance, timeslot, displayAs)),
    shouldDisplayWatchNow = _ref7.shouldDisplayWatchNow,
    productId = _ref7.productId,
    performanceId = _ref7.performanceId,
    timeslotId = _ref7.timeslotId,
    buyActionUrl = _ref7.buyActionUrl,
    accessCode = _ref7.accessCode,
    isAlreadyWatch = _ref7.isAlreadyWatch,
    isLoginRequired = _ref7.isLoginRequired;
  var accessibilityHeadingTitle = (cov_2cb95nfw4g().s[83]++, "".concat(keyPrefix).concat(ACCESSIBILITY_TITLE_PREFIX).concat(product.id));
  var isCheckResaleAvailabilityVisible = (cov_2cb95nfw4g().s[84]++, (0, _utils2.getResaleAvailabilityVisibility)(soldOut, resaleAvailability, product));
  var resaleURL = (cov_2cb95nfw4g().s[85]++, (0, _utils2.buildResaleURL)(product, performance, resaleAvailability));
  cov_2cb95nfw4g().s[86]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    isShowSelectCheckbox: isShowSelectCheckbox,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 455,
      columnNumber: 5
    }
  }, selectCheckbox, /*#__PURE__*/_react.default.createElement(ProductCardMainContent, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 457,
      columnNumber: 7
    }
  }, (cov_2cb95nfw4g().b[39][0]++, !soldOut) && (cov_2cb95nfw4g().b[39][1]++, mainAction) && (cov_2cb95nfw4g().b[39][2]++, showDescription) && (cov_2cb95nfw4g().b[39][3]++, (0, _utils2.isDisplayTooltip)(performance, product)) && (cov_2cb95nfw4g().b[39][4]++, themeQueries.EQUILIBRIUM) && (cov_2cb95nfw4g().b[39][5]++, /*#__PURE__*/_react.default.createElement(TooltipWrapper, {
    mouseLeaveDelay: 0,
    placement: "bottom",
    overlay: htmlTooltip,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 462,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(MainActionArea, (0, _extends2.default)({}, _ProductHelper.default.getActionHandler(props, product.id, mainAction), {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 463,
      columnNumber: 15
    }
  }), /*#__PURE__*/_react.default.createElement(TitleWrapper, {
    "aria-live": "polite",
    id: accessibilityHeadingTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 464,
      columnNumber: 17
    }
  }, productTitle)))) || (cov_2cb95nfw4g().b[39][6]++, !soldOut) && (cov_2cb95nfw4g().b[39][7]++, mainAction) && (cov_2cb95nfw4g().b[39][8]++, /*#__PURE__*/_react.default.createElement(MainActionArea, (0, _extends2.default)({}, _ProductHelper.default.getActionHandler(props, product.id, mainAction), {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 472,
      columnNumber: 15
    }
  }), /*#__PURE__*/_react.default.createElement(TitleWrapper, {
    "aria-live": "polite",
    id: accessibilityHeadingTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 473,
      columnNumber: 17
    }
  }, productTitle))), (cov_2cb95nfw4g().b[40][0]++, showImage) && (cov_2cb95nfw4g().b[40][1]++, /*#__PURE__*/_react.default.createElement(_ProductIndicator.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 479,
      columnNumber: 11
    }
  })), image, ((cov_2cb95nfw4g().b[41][0]++, showTitle) || (cov_2cb95nfw4g().b[41][1]++, showPrice) || (cov_2cb95nfw4g().b[41][2]++, showDescription)) && (cov_2cb95nfw4g().b[41][3]++, /*#__PURE__*/_react.default.createElement(_ProductCardDetails.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    showDate: (cov_2cb95nfw4g().b[42][0]++, !showOccurrences) && (cov_2cb95nfw4g().b[42][1]++, showDate),
    showTime: showTime,
    showTitle: showTitle,
    showDescription: showDescription,
    showPrice: showPrice,
    currencyCode: currencyCode,
    productTitleFontSize: productTitleFontSize,
    replaceProductNameByPerformance: usePerformanceName,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 483,
      columnNumber: 11
    }
  }))), shouldDisplayWatchNow ? (// The watchNow action here should take no effect due to onActionClick has already handled it
  cov_2cb95nfw4g().b[43][0]++, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    onActionClick: function onActionClick() {
      cov_2cb95nfw4g().f[10]++;
      cov_2cb95nfw4g().s[87]++;
      return onWatchStreamOnline({
        productId: productId,
        performanceId: performanceId,
        timeslotId: timeslotId
      }, buyActionUrl, isLoginRequired);
    },
    inline: true,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    actions: isAlreadyWatch ? (cov_2cb95nfw4g().b[44][0]++, {
      reWatch: (0, _get.default)(product, 'action.watchNow', '')
    }) : (cov_2cb95nfw4g().b[44][1]++, {
      watchNow: (0, _get.default)(product, 'action.watchNow', '')
    }),
    buttonNote: accessCode !== '' ? (cov_2cb95nfw4g().b[45][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'streamOnline.label.accessCode',
      values: {
        code: accessCode
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 519,
        columnNumber: 15
      }
    })) : (cov_2cb95nfw4g().b[45][1]++, null),
    accessibilityActionLabel: productTitle,
    buttonVariant: actionButtonVariant,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 499,
      columnNumber: 9
    }
  })) : (cov_2cb95nfw4g().b[43][1]++, (cov_2cb95nfw4g().b[46][0]++, displayActions) && (cov_2cb95nfw4g().b[46][1]++, action) && (cov_2cb95nfw4g().b[46][2]++, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    onActionClick: onActionClick,
    inline: true,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    accessibilityActionLabel: productTitle,
    buttonVariant: actionButtonVariant,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 531,
      columnNumber: 11
    }
  }))), (cov_2cb95nfw4g().b[47][0]++, displayOccurrences) && (cov_2cb95nfw4g().b[47][1]++, /*#__PURE__*/_react.default.createElement(_ProductSlotsBtn.default, {
    product: product,
    maxOccurrences: maxOccurrences,
    onActionClick: onActionClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 544,
      columnNumber: 9
    }
  })), (cov_2cb95nfw4g().b[48][0]++, displayWaitingList) && (cov_2cb95nfw4g().b[48][1]++, action) && (cov_2cb95nfw4g().b[48][2]++, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
    product: product,
    actions: {
      subscribe: product.waitingListUrl
    },
    inline: true,
    onActionClick: onActionClick,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    accessibilityActionLabel: productTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 552,
      columnNumber: 11
    }
  })), (cov_2cb95nfw4g().b[49][0]++, isCheckResaleAvailabilityVisible) && (cov_2cb95nfw4g().b[49][1]++, /*#__PURE__*/_react.default.createElement(_CheckResaleAvailability.default, {
    justifyContentDirection: "center",
    onCheckResaleAvalClickHandler: function onCheckResaleAvalClickHandler() {
      cov_2cb95nfw4g().f[11]++;
      cov_2cb95nfw4g().s[88]++;
      return window.open(resaleURL, '_blank');
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 562,
      columnNumber: 9
    }
  })), /*#__PURE__*/_react.default.createElement(_jsonMetadata.default, {
    jsonMetadata: product.jsonMetadata,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 567,
      columnNumber: 7
    }
  }));
}
cov_2cb95nfw4g().s[89]++;
ProductCard.propTypes = {
  /** The display ratio of the picture : TODO : inform what aspect ratio correspond to which value */
  aspectRatio: _propTypes.default.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /* Define how many occurences buttons are allowed */
  maxOccurrences: _propTypes.default.number,
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Should we display the buttons to access the ts pages (buy, reserve, request, option) */
  showActions: _propTypes.default.bool,
  /* Should we display the product image */
  showImage: _propTypes.default.bool,
  /* Should we display the buttons to access the ts pages (list of performances or occurences) */
  showOccurrences: _propTypes.default.bool,
  /* Should we display the product details (name, subname, time range) */
  showTitle: _propTypes.default.bool,
  /* Show waiting list in case of sold out, get the accordingButton */
  waitingListEnabled: _propTypes.default.bool,
  /* Show product description */
  showDescription: _propTypes.default.bool,
  /* Show product price minimum */
  showPrice: _propTypes.default.bool,
  /* Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /* Give the possibility to hide the date. */
  showDate: _propTypes.default.bool,
  /* Give the possibility to hide the time. */
  showTime: _propTypes.default.bool,
  /* Product title font-size */
  productTitleFontSize: _propTypes.default.string,
  /** The function called when clicking on the product or occurence action */
  onActionClick: _propTypes.default.func,
  /* Should show select checkbox */
  isShowSelectCheckbox: _propTypes.default.bool,
  /* Should show select checkbox is selected */
  isSelected: _propTypes.default.bool,
  /* The function called when change the product select checkbox */
  onProductSelectChange: _propTypes.default.func,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Function to handle watch stream online */
  onWatchStreamOnline: _propTypes.default.func,
  displayAs: _propTypes.default.oneOf(['PRODUCT', 'PERFORMANCE', 'TOUR']),
  intl: _reactIntl.intlShape.isRequired,
  /** Key to generate unique id for product title */
  keyPrefix: _propTypes.default.string,
  replaceProductNameByPerformance: _propTypes.default.bool,
  resaleAvailability: _propTypes.default.shape({}),
  /** theme context */
  themeQueries: _utils.WithThemeQueriesType,
  /** Product actions */
  actionButtonVariant: _button.ButtonVariantType,
  lastItemId: _propTypes.default.number,
  columns: _propTypes.default.number,
  showAsGrid: _propTypes.default.bool
};
cov_2cb95nfw4g().s[90]++;
ProductCard.defaultProps = {
  showImage: true,
  showTitle: true,
  showActions: false,
  showPrice: false,
  showOccurrences: false,
  showDescription: false,
  waitingListEnabled: false,
  maxOccurrences: 5,
  aspectRatio: undefined,
  currencyCode: null,
  performance: null,
  timeslot: null,
  isSignedIn: false,
  showDate: undefined,
  showTime: undefined,
  productTitleFontSize: null,
  onActionClick: null,
  isShowSelectCheckbox: false,
  isSelected: false,
  onProductSelectChange: null,
  isLandingPage: false,
  onWatchStreamOnline: null,
  displayAs: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    userInfo: {},
    useGA4: false
  },
  keyPrefix: null,
  replaceProductNameByPerformance: false,
  resaleAvailability: {},
  themeQueries: {},
  actionButtonVariant: _button.ButtonVariant.primary,
  lastItemId: 0,
  columns: 0,
  showAsGrid: false
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _reactIntl.injectIntl)(ProductCard)));